import { NotificationsActive } from "@mui/icons-material";
import { Badge, IconButton, styled, Tooltip } from "@mui/material";
import { useNotifications } from "../hooks/useNotifications";
import { NotificationMenu } from "../components/NotificationMenu";
import { useState } from "react";

interface AnimatedBellProps {
  animate?: boolean;
}

const AnimatedBell = styled(NotificationsActive, {
  shouldForwardProp: (prop) => prop !== "animate",
})<AnimatedBellProps>(({ theme, animate }) => ({
  color: animate ? theme.palette.action.active : theme.palette.action.active,
  transformOrigin: "top center",
  animation: animate ? "ring 0.8s ease-in-out" : "none",
  "@keyframes ring": {
    "0%": { transform: "rotate(0deg)" },
    "15%": { transform: "rotate(15deg)" },
    "30%": { transform: "rotate(-10deg)" },
    "45%": { transform: "rotate(8deg)" },
    "60%": { transform: "rotate(-6deg)" },
    "75%": { transform: "rotate(4deg)" },
    "100%": { transform: "rotate(0deg)" },
  },
}));

export const Notifications = () => {
  const {
    notifications,
    unreadCount,
    hasNew,
    isLoading,
    loadNotifications,
    hasMore,
  } = useNotifications();

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const isMenuOpen = Boolean(anchorEl);

  const handleBellClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Tooltip title="Notifications">
        <IconButton onClick={handleBellClick}>
          <Badge
            badgeContent={unreadCount}
            max={999}
            color="error"
            invisible={unreadCount === 0}
          >
            <AnimatedBell animate={hasNew || unreadCount > 0} />
          </Badge>
        </IconButton>
      </Tooltip>
      <NotificationMenu
        anchorEl={anchorEl}
        open={isMenuOpen}
        onClose={handleMenuClose}
        notifications={notifications}
        loadNotifications={loadNotifications}
        hasMore={hasMore}
        isLoading={isLoading}
      />
    </>
  );
};
